import { Theme } from "@mui/material";

export const useTabStyles = (_theme: Theme) => ({
  paper: {
    padding: 2,
    gap: 2,
    width: "100%",
    flexDirection: "column",
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
    minWidth: "320px",
    borderRadius: "0px 5px 5px 5px",
  },
  boxTable: {
    width: "100%",
  },
  iconButtonAction: {
    color: _theme.palette.text.primary,
  },
});
